import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "../../api/axios";
import { destroySession } from "../../helpers/Session";
import DataTable from "react-data-table-component";
import LocationLoader from "../../components/loader/LocationLoader";

const Locations = () => {
    const navigate = useNavigate();

    const timeoutRef = useRef(null);
    
    const accesstoken = sessionStorage.getItem('accesstoken') || '';
    const departmentslug = sessionStorage.getItem('departmentslug') || '';

    const [currentPage, setCurrentPage] = useState(1);
    const [rowPerPage, setRowPerPage] = useState(10);

    const tableColumns = [
        { name: 'Name', selector: row => row.name },
        { name: 'Department', selector: row => row.department },
        { name: 'Action', selector: row => row.type },
        { name: 'Latitude', selector: row => row.latitude },
        { name: 'Longitude', selector: row => row.longitude },
        { name: 'Location', selector: row => row.location },
        { name: 'Logged At', selector: row => row.loggeddate }
    ];

    const { data: locations, isLoading, error } = useQuery({
        queryKey: ['locations', departmentslug, currentPage, rowPerPage],
        queryFn: async () => {
            const res = await axios.get(`locations?department=${departmentslug}&page=${currentPage}&rows_per_page=${rowPerPage}`, {
                headers: { 'Authorization': `Bearer ${accesstoken}` }
            });
            return res.data.response;
        },
        enabled: !!departmentslug,
        retry: 1
    });

    useEffect(() => {
        if (error) {
            if (error.response?.data?.status === 'inactive') {
                destroySession();
                clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(() => { navigate('/error'); }, 1000);
            }
        }
    }, [error, navigate]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    }

    const handleRowsPerPageChange = (newPerPage) => {
        setRowPerPage(newPerPage);
        setCurrentPage(1);
    }

    return (
        <div className="locations">
            <div className="page-header">
                <div className='title'>
                    <h1>Locations</h1>
                    <ul className='breadcrumbs'>
                        <li>
                            <NavLink to='/logs/actions'>Logs</NavLink>
                        </li>
                        <li>
                            <span>Locations</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div className='panels'>
                <div className="left-panel">
                    <DataTable 
                        columns={tableColumns}
                        data={locations?.locations || []}
                        progressPending={isLoading}
                        progressComponent={<LocationLoader />}
                        pagination
                        paginationServer
                        paginationTotalRows={locations?.totalRows || 0}
                        onChangeRowsPerPage={handleRowsPerPageChange}
                        onChangePage={handlePageChange}
                        dense
                        highlightOnHover
                        responsive
                    />
                </div>
            </div>
        </div>
    )
}

export default Locations;